
    <div [class]="'alert alert-' + type + (dismissible ? ' alert-dismissible' : '')" role="alert">
      <button *ngIf="dismissible" type="button" class="close" aria-label="Close" (click)="closeHandler()">
            <span aria-hidden="true">&times;</span>
      </button>
      <ng-content></ng-content>
    </div>
    


// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/node_modules/@ng-bootstrap/ng-bootstrap/alert/alert.d.ts.NgbAlert.html